// @flow
import createIcon from './utils/createIcon'

export default createIcon({
  iconName: 'angle-right',
  icon: [
    192,
    512,
    null,
    null,
    'M166.9 264.5l-117.8 116a12 12 0 0 1-17 0l-7.1-7.1a12 12 0 0 1 0-17L127.3 256 25.1 155.6a12 12 0 0 1 0-17l7.1-7.1a12 12 0 0 1 17 0l117.8 116a12.1 12.1 0 0 1-.1 17z',
  ],
})
